import { createFileRoute, redirect } from "@tanstack/react-router";

/** The Devices page lives on as Security › Sessions; old links land there. */
export const Route = createFileRoute("/_authed/settings/devices")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/security" });
  },
});
